const QUESTION_TYPES = {
  listSelectionOption: 1,
  text: 2,
  other: 3,
  pairMatchOption: 5,
  textInputOption: 6,
};

export default {
  QUESTION_TYPES,
};
